import PropTypes from "prop-types";
import React, { Component } from "react";
import { setItemBreadcrumbs, setReturnedValue } from "../actions";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core";
import "../index.css";
import Icon from "@material-ui/core/Icon";
import { DatePicker } from "@material-ui/pickers";
import { DateTime } from "luxon";
import { Trans } from "@lingui/macro";
import { translator } from "../utils/i18n";

const styles = {};

class ADate extends Component {
  state = {
    date: null
  };

  buildBreadcrumbs = value => {
    const element = { textItem: value, stepItem: { ...this.props.activeStep } };
    this.props.setBreadcrumbs(element);
  };

  handleChange = selectedDate => {
    const keyValueReturned = this.props.step.returned.key;
    if (selectedDate !== "") {
      const strDate = selectedDate
        .setLocale("fr")
        .toLocaleString(DateTime.DATE_SHORT);
      this.props.setReturnedValue({ [keyValueReturned]: strDate });
      this.buildBreadcrumbs(strDate);
      this.props.isValid(true);
    } else {
      this.props.isValid(false);
    }
    this.setState({ date: selectedDate });
  };

  render() {
    const step = this.props.step;
    const now = DateTime.local();
    const initialDate = now.plus({ days: 7 }); // next week
    return (
      <div className="content-widget bloc-date">
        <DatePicker
          disableToolbar
          id="date"
          name="date"
          label={step.component.label}
          value={this.state.date}
          minDate={now}
          initialFocusedDate={initialDate}
          onAccept={this.handleChange}
          onChange={() => {}}
          className="custom-date wrap-input"
          fullWidth={true}
          autoOk
          inputVariant="outlined"
          invalidDateMessage={<Trans id="W_DATE_INVALID" />}
          format={"dd/MM/yyyy"}
          shouldDisableDate={day => day.weekday === 6 || day.weekday === 7}
          cancelLabel={<Trans id="W_ANNULER" />}
          okLabel={<Trans id="W_STEP_POPUP_BOUTON_OK" />}
          minDateMessage={translator()._("W_MIN_DATE_ALERT")}
        />
        <Icon className="blue icon-date">date_range</Icon>
      </div>
    );
  }
}

ADate.propTypes = {
  activeStep: PropTypes.any,
  isValid: PropTypes.func,
  setBreadcrumbs: PropTypes.func,
  setReturnedValue: PropTypes.func,
  step: PropTypes.shape({
    component: PropTypes.shape({
      label: PropTypes.any
    }),
    returned: PropTypes.shape({
      key: PropTypes.any
    })
  })
};

const mapStateToProps = state => {
  return {
    activeStep: state.activeStep
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setReturnedValue: value => dispatch(setReturnedValue(value)),
    setBreadcrumbs: item => dispatch(setItemBreadcrumbs(item))
  };
};

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ADate)
);
